import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { retry, map, catchError } from 'rxjs/operators';
import { Approval } from './approval.model';

@Injectable({
  providedIn: 'root'
})
export class ApprovalService {

  constructor(public http: HttpClient) { }

  createApproval(approval: Approval): Observable<any> {
    return this.http.post<any>('/api/approvals', approval);
  }

  getApprovals(): Observable<any> {
    return this.http.get('/api/approvals')
      .pipe(
        retry(3),
        map(
          result => result
        ),
        catchError(this.errorHandler)
      );
  }

  deleteApproval(id: string): Observable<any> {
    return this.http.delete(`/api/approvals/${id}`);
  }

  private errorHandler(error: HttpErrorResponse): Observable<never> {
    console.error('Fehler aufgetreten!');
    return throwError(error);
  }
}
